module.exports = __webpack_public_path__ + "91e8c05a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/favicon-114x114.png
// module id = 1512
// module chunks = 0